import { t } from '@gem/modules/i18n';
import { popupsTasks } from '@gem/popups';

import Tasks from 'APP/Tasks';
import { ILogoutCalendarParams } from 'APP/model/calendar/calendar.types';
import { calendarModel } from 'APP/model/model';

export async function logoutCalendar(params: ILogoutCalendarParams): Promise<boolean> {
  try {
    const response = await calendarModel.logoutCalendar(params);

    const accounts = await Tasks.calendar.getAuthorizationAccounts();

    const isNotCalendarAccount = !accounts?.find(
      (account) => account.account.providerEmail === params.account.providerEmail
    );

    if (isNotCalendarAccount) {
      popupsTasks.showToast(t('calendar_disconnect_success'));
    } else {
      popupsTasks.showToast(t('something_went_wrong'));
    }

    return response;
  } catch {
    return false;
  }
}
